import { MGPFallible } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
import { DvonnFailure } from './DvonnFailure';
import { DvonnState } from './DvonnState';
export class DvonnMove extends MoveCoordToCoord {
    static PASS = new DvonnMove(new Coord(-1, -1), new Coord(-2, -2));
    static encoder = MoveWithTwoCoords.getFallibleEncoder(DvonnMove.from);
    constructor(start, end) {
        super(start, end);
    }
    static from(start, end) {
        if (start.x === -1 && start.y === -1 && end.x === -2 && end.y === -2) {
            // PASS move
            return MGPFallible.success(DvonnMove.PASS);
        }
        // Move should be on board
        if (DvonnState.isNotOnBoard(start)) {
            return MGPFallible.failure('Starting coord of DvonnMove must be on the board, not at ' + start.toString());
        }
        if (DvonnState.isNotOnBoard(end)) {
            return MGPFallible.failure('End coord of DvonnMove must be on the board, not at ' + start.toString());
        }
        // Move should be a straight line
        if (start.y === end.y) {
            // vertical move, allowed
            return MGPFallible.success(new DvonnMove(start, end));
        }
        else if (start.x === end.x) {
            // horizontal move, allowed
            return MGPFallible.success(new DvonnMove(start, end));
        }
        else if (start.x + start.y === end.x + end.y) {
            // diagonal move, allowed
            return MGPFallible.success(new DvonnMove(start, end));
        }
        else {
            return MGPFallible.failure(DvonnFailure.MUST_MOVE_IN_STRAIGHT_LINE());
        }
    }
    toString() {
        if (this === DvonnMove.PASS) {
            return 'DvonnMove.PASS';
        }
        return 'DvonnMove(' + this.getStart() + '->' + this.getEnd() + ')';
    }
    getDistance() {
        if (this.getStart().y === this.getEnd().y) {
            return Math.abs(this.getStart().x - this.getEnd().x);
        }
        else if (this.getStart().x === this.getEnd().x) {
            return Math.abs(this.getStart().y - this.getEnd().y);
        }
        else {
            return Math.abs(this.getStart().y - this.getEnd().y);
        }
    }
}
